let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3NE3l")).then(() => parcelRequire('5bJFE'));